// JS
mixin = {
    Get: function (url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
            callback(this.response);
            }
        };
        xhr.open("GET", url, true);
        xhr.send();
    }
}

class InstagramGrid extends HTMLElement {
    constructor() {
        super();

        this.grid = this.querySelector('[section-grid]');
        this.grid_element = this.querySelector('[instagram-grid-element]')

        this.amount = this.dataset.amount;
        this.height = this.dataset.height;
        this.facebook_id = this.dataset.facebookId;

        this.instatiate()
    }

    instatiate() {
        mixin.Get("https://facebook-api.sgme.as/umbraco/surface/facebook/GetInstagramFeed?facebookId="+ this.facebook_id +"&amount=" + this.amount, res => {
            var posts = JSON.parse(res);

            posts.forEach(post => {
                const clone = this.grid_element.content.cloneNode(true);

                clone.querySelector('img').src = post.thumbnail_url != null ? post.thumbnail_url : post.media_url;
                clone.querySelector('img').style.height = this.height + "px";
                clone.querySelector('a').href = post.permalink;
                clone.querySelector('.likes').innerText = post.like_count;

                this.grid.appendChild(clone)
            });
        });
    }
}

customElements.define("instagram-grid", InstagramGrid);
